import { Outlet, Navigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import { useAuth } from '@/hooks/useAuth'

export function AuthLayout() {
  const { isAuthenticated } = useAuth()

  // Redirect if already authenticated (but not during initial load)
  if (isAuthenticated) {
    return <Navigate to="/feed" replace />
  }

  // Don't show loading state for auth pages - let them handle their own loading

  return (
    <div className="flex min-h-screen">
      {/* Left side - Branding */}
      <div className="hidden lg:flex lg:w-1/2 lg:flex-col lg:justify-between gradient-bg p-12 text-white">
        <div>
          <h1 className="font-display text-4xl font-bold">KLASSIC</h1>
          <p className="mt-2 text-lg opacity-90">Where moments become timeless</p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3, duration: 0.5 }}
          className="space-y-8"
        >
          <blockquote className="text-xl font-light italic">
            &ldquo;The best social experience for our generation. Finally, something that gets us.&rdquo;
          </blockquote>
          <div className="flex items-center gap-4">
            <div className="h-12 w-12 rounded-full bg-white/20" />
            <div>
              <p className="font-medium">Sarah M.</p>
              <p className="text-sm opacity-75">@sarahcreates</p>
            </div>
          </div>
        </motion.div>

        <div className="flex flex-wrap gap-4 text-sm opacity-75">
          <a href="#" className="hover:underline">About</a>
          <a href="#" className="hover:underline">Privacy</a>
          <a href="#" className="hover:underline">Terms</a>
          <a href="#" className="hover:underline">Help</a>
        </div>
      </div>

      {/* Right side - Auth form */}
      <div className="flex w-full flex-col justify-center px-4 py-12 lg:w-1/2 lg:px-12">
        {/* Mobile logo */}
        <div className="mb-8 text-center lg:hidden">
          <h1 className="font-display text-3xl font-bold text-primary">KLASSIC</h1>
          <p className="mt-1 text-sm text-muted-foreground">Where moments become timeless</p>
        </div>

        <div className="mx-auto w-full max-w-md">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3 }}
          >
            <Outlet />
          </motion.div>
        </div>

        {/* Mobile footer */}
        <div className="mt-8 flex justify-center gap-4 text-xs text-muted-foreground lg:hidden">
          <a href="#" className="hover:underline">About</a>
          <a href="#" className="hover:underline">Privacy</a>
          <a href="#" className="hover:underline">Terms</a>
        </div>
      </div>
    </div>
  )
}
